import { MenuGridItemConfiguration } from '@menuGridGenerator/models';
import { MenuEdition } from './menuEdition';
import { ProductItem } from './productItem';

export class Section extends MenuEdition {
  static CLAUSE_LIST_GUID = null;

  static CLAUSE_LIST_TYPE = 0;

  constructor(props = {}) {
    super(props.guid);
    this.title_alt1 = props.title_alt1 || '';
    this.title_alt2 = props.title_alt2 || '';
    this.title_alt3 = props.title_alt3 || '';
    this.order = props.order || 0;
    this.type = props.type || Section.CLAUSE_LIST_TYPE;
    this.parent_section = props.parent_section || Section.CLAUSE_LIST_GUID;
    this.menu = props.menu || '';
    this.sections = Section.toInstanceList(props.sections) || [];
    this.products = ProductItem.toInstanceList(props.products) || [];
    this.is_visible = props.is_visible;
    this.has_managed_products = props.has_managed_products;
    this.description_alt1 = props.description_alt1;
    this.description_alt2 = props.description_alt2;
    this.description_alt3 = props.description_alt3;
    this.description_bottom = props.description_bottom;
    this.description_highlighted = props.description_highlighted;
    this.menu_grid_item_configuration = props.menu_grid_item_configuration ? MenuGridItemConfiguration.toInstance(props.menu_grid_item_configuration) : null;
  }

  get title() {
    return this.title_alt1;
  }

  overwrite(section) {
    this.title_alt1 = section.title_alt1 || '';
    this.title_alt2 = section.title_alt2 || '';
    this.title_alt3 = section.title_alt3 || '';
    this.order = section.order || 0;
    this.is_visible = section.is_visible;
    this.has_managed_products = section.has_managed_products;
    this.description_alt1 = section.description_alt1 || '';
    this.description_alt2 = section.description_alt2 || '';
    this.description_alt3 = section.description_alt3 || '';
    this.description_bottom = section.description_bottom;
    this.description_highlighted = section.description_highlighted;
    this.menu_grid_item_configuration = section.menu_grid_item_configuration;
    return this;
  }

  serialize() {
    const serializedData = {
      guid: this.guid,
      title_alt1: this.title_alt1,
      title_alt2: this.title_alt2,
      title_alt3: this.title_alt3,
      order: this.order,
      type: this.type,
      parent_section: this.parent_section,
      menu: this.menu,
      sections: this.sections,
      products: this.products,
      is_visible: this.is_visible,
      has_managed_products: this.has_managed_products,
      description_alt1: this.description_alt1,
      description_alt2: this.description_alt2,
      description_alt3: this.description_alt3,
      description_bottom: this.description_bottom,
      description_highlighted: this.description_highlighted,
    };
    if (this.menu_grid_item_configuration) {
      serializedData.menu_grid_item_configuration = this.menu_grid_item_configuration.serialize();
    }
    return serializedData;
  }

  hasManagedProducts() {
    if (this.products.some((product) => product.is_managed)) return true;
    return this.sections.some((subsection) => subsection.hasManagedProducts());
  }

  getParentSections(getSectionByGuid) {
    if (!this.parent_section) return [];
    const parentSection = getSectionByGuid(this.parent_section);
    return [parentSection, ...parentSection.getParentSections(getSectionByGuid)];
  }
}
